'use strict';

import moment from 'moment' ;

function DeletedColorDirective() {
    return {
        restrict: 'A',
        scope: {
            approvedAt: '<'
        },
        link: function(scope, element, attrs, controller) {
            if (scope.approvedAt) {
                element.addClass('approved-color');
            } else {
                element.addClass('not-approved-color');
            }
        }
    };
}

export default DeletedColorDirective;
